module.exports = "/cyber/_next/static/images/winners-bg-desktop-25336c9b56f477b9e96e75044a51b89e.jpg";